export interface BatchCall {
    to: string;
    data: string;
    value?: string;
}
